import { useCallback, useEffect } from "react";

import useFileImportStore from "../../../stores/fileImportStore";

export default function useParseFileData() {
  const currentUnparsedBOM = useFileImportStore((s) => s.currentUnparsedBOM);
  const parsedHeaders = useFileImportStore((s) => s.headers);
  const parsedFinishedGood = useFileImportStore((s) => s.parsedFinishedGood);
  const parsedComponents = useFileImportStore((s) => s.parsedComponents);

  const parseHeaders = useCallback(() => {
    useFileImportStore.getState().setHeaders(Object.keys(currentUnparsedBOM[0]));
  }, [currentUnparsedBOM]);

  const extractFinishedGood = useCallback(() => {
    const fg = currentUnparsedBOM.find((data) => data.Item === "FG");
    useFileImportStore.getState().setParsedFinishedGood(Object.values(fg).map((val) => String(val)));
  }, [currentUnparsedBOM]);

  const extractComponents = useCallback(() => {
    const components = currentUnparsedBOM.filter((data) => data.Item === "Component");
    useFileImportStore.getState().setParsedComponents(
      components.map((component) => {
        const result = Object.values(component).map((val) => String(val));
        return result;
      }),
    );
  }, [currentUnparsedBOM]);

  useEffect(() => {
    if (currentUnparsedBOM && parseHeaders) {
      parseHeaders();
    }
  }, [currentUnparsedBOM, parseHeaders]);

  useEffect(() => {
    if (parsedHeaders) {
      extractFinishedGood();
      extractComponents();
    }
  }, [parsedHeaders, extractComponents, extractFinishedGood]);

  useEffect(() => {
    if (currentUnparsedBOM && parsedHeaders && parsedComponents && parsedFinishedGood) {
      useFileImportStore.getState().setParsingDone(true);
    } else {
      useFileImportStore.getState().setParsingDone(false);
    }
  }, [currentUnparsedBOM, parsedHeaders, parsedComponents, parsedFinishedGood]);
}
